import { Box, Divider, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Drawer, TitleBox } from './styles';
import { forwardRef } from 'react';
import RiskAssessmentDrawerTabs from './tabs';

interface RiskAssessmentDrawerProps {
  assemblyName: string | undefined;
  setDrawerOpen: (open: boolean) => void;
  setSelectedAssemblyId: (assembly: string | undefined) => void;
  setSelectedAssemblyName: (assembly: string | undefined) => void;
}

export const RiskAssessmentDrawer = forwardRef<HTMLDivElement, RiskAssessmentDrawerProps>(
  (
    { assemblyName, setDrawerOpen, setSelectedAssemblyId, setSelectedAssemblyName },
    drawerReference
  ) => {
    return (
      <Box sx={Drawer} ref={drawerReference}>
        <Box sx={TitleBox}>
          <Typography variant="h4">{assemblyName ?? 'Structure Details'}</Typography>
          <IconButton
            aria-label="close"
            onClick={() => {
              setSelectedAssemblyName(undefined);
              setSelectedAssemblyId(undefined);
              setDrawerOpen(false);
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Divider sx={{ marginBottom: '20px' }} />
        <RiskAssessmentDrawerTabs />
      </Box>
    );
  }
);
